import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormBuilder } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { fuseAnimations } from '../../../../../../../core/animations';
import { TranslationService } from '../../../../../../services/translation/translation.service';
import { SweetAlertService } from '../../../../../../services/sweet-alert/sweet-alert.service';
import { environment } from '../../../../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { TypeEmployeeService } from '../../../../../../services/type-employee/type-employee.service';
import { ShiftService } from '../../../../../../services/shifts/shift.service';
import { JobTitleService } from '../../../../../../services/jobtitle/jobtitle.service';
import { ConfigService } from '../../../../../../services/config/config.service';


@Component({
    selector: 'fuse-employee-index-card-configuration',
    templateUrl: './employee-index-card-configuration.component.html',
    styleUrls: ['./employee-index-card-configuration.component.scss'],
    animations: fuseAnimations
})
export class EmployeeIndexCardConfigurationComponent implements OnInit {
    @BlockUI() blockUI: NgBlockUI;
    formGroup;


    public typeEmployees = [];
    public jobTitles = [];
    public shifts = [];

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<EmployeeIndexCardConfigurationComponent>,
        private translationService: TranslationService,
        private sweetAlertService: SweetAlertService,
        private fb: FormBuilder,
        public typeEmployeeService: TypeEmployeeService,
        public shiftService: ShiftService,
        private jobTitleService: JobTitleService,
        private configService: ConfigService
    ) {
        console.log('FuseAddStudentComponent > data', data);
    }

    ngOnInit() {
        this.blockUI.start(this.translationService.loading);
        Observable.combineLatest(
            this.typeEmployeeService.getAll(),
            this.jobTitleService.getAll(),
            this.shiftService.getAll()
        ).subscribe(([typeEmployees, jobTitles, shifts]) => {
            this.typeEmployees = typeEmployees.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            this.jobTitles = jobTitles.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            this.shifts = shifts.map(e => {
                return {Id: e.Id, Description: e.Description, Checked: false};
            });

            this.blockUI.stop();
        }, error => {
            this.blockUI.stop();
            this.translationService.translate('ERRORS.ERROR_REQUEST', error, (res: string) => {
                this.sweetAlertService.error('Error', res, null);
            });
        });
    }

    required(list) {
        return list.filter(e => e.Checked).length === 0;
    }


    save() {
        const typeEmployees = this.typeEmployees.filter(e => e.Checked).map(e => e.Id);
        const jobTitles = this.jobTitles.filter(e => e.Checked).map(e => e.Id);
        const shifts = this.shifts.filter(e => e.Checked).map(e => e.Id);
        window.open(environment.backendUri + 'report/allindexcard/' + jobTitles + '/' + typeEmployees + '/' + shifts, '_new');
    }
}



// WEBPACK FOOTER //
// ./src/app/main/content/pages/management/employees/components/employee-index-card-configuration/employee-index-card-configuration.component.ts